// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILetterOfMedicalNecessityClaimDto
 */
export interface ILetterOfMedicalNecessityClaimDto {
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityClaimDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityClaimDto
     */
    provider_name?: string;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityClaimDto
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityClaimDto
     */
    service_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityClaimDto
     */
    category_type?: ILetterOfMedicalNecessityClaimDtoCategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityClaimDto
     */
    approval_status?: ILetterOfMedicalNecessityClaimDtoApprovalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityClaimDto
     */
    status_type?: ILetterOfMedicalNecessityClaimDtoStatusTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityClaimDto
     */
    requested_amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityClaimDto
     */
    service_on?: Date;
}

/**
* @export
* @enum {string}
*/
export enum ILetterOfMedicalNecessityClaimDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum ILetterOfMedicalNecessityClaimDtoApprovalStatusEnum {
    PENDING_REVIEW = 'PENDING_REVIEW',
    UNDER_REVIEW = 'UNDER_REVIEW',
    DOCS_NEEDED = 'DOCS_NEEDED',
    INCOMPLETE = 'INCOMPLETE',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    CANCELLED = 'CANCELLED',
    VOIDED = 'VOIDED'
}
/**
* @export
* @enum {string}
*/
export enum ILetterOfMedicalNecessityClaimDtoStatusTypeEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}


/**
 * Check if a given object implements the ILetterOfMedicalNecessityClaimDto interface.
 */
export function instanceOfILetterOfMedicalNecessityClaimDto(value: object): value is ILetterOfMedicalNecessityClaimDto {
    return true;
}

export function ILetterOfMedicalNecessityClaimDtoFromJSON(json: any): ILetterOfMedicalNecessityClaimDto {
    return ILetterOfMedicalNecessityClaimDtoFromJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityClaimDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILetterOfMedicalNecessityClaimDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'service_name': json['service_name'] == null ? undefined : json['service_name'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'approval_status': json['approval_status'] == null ? undefined : json['approval_status'],
        'status_type': json['status_type'] == null ? undefined : json['status_type'],
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
    };
}

export function ILetterOfMedicalNecessityClaimDtoToJSON(json: any): ILetterOfMedicalNecessityClaimDto {
    return ILetterOfMedicalNecessityClaimDtoToJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityClaimDtoToJSONTyped(value?: ILetterOfMedicalNecessityClaimDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'provider_name': value['provider_name'],
        'service_id': value['service_id'],
        'service_name': value['service_name'],
        'category_type': value['category_type'],
        'approval_status': value['approval_status'],
        'status_type': value['status_type'],
        'requested_amount': value['requested_amount'],
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString().substring(0,10)),
    };
}

